import Image from "next/image"

import { withPalette } from "@/components/marketplace/palette"
import type { Palette } from "@/components/marketplace/palette"
import { Heading, Stack, Text } from "@/components/ui"
import { PRODUCT_PHOTO_QUALITY, TileImage } from "@/components/ui/tile-image"

export interface ListingBannerCutout {
  src: string
  className: string
  sizes?: string
}

interface ListingBannerProps {
  eyebrow: string
  title: string
  image?: string
  palette?: Palette
  cutouts?: ListingBannerCutout[]
}

// A strip, not a hero: it names the page and gets out of the way so the first row of
// products is on screen. It sizes to its two lines of copy instead of a fixed height,
// except with cutouts, which need the full 200px to show their art.
export const ListingBanner = ({ eyebrow, title, image, palette, cutouts }: ListingBannerProps) => (
  <section className={withPalette(palette, `rounded-10x relative isolate overflow-hidden ${image ? "" : "bg-listing-banner"} ${!image && cutouts?.length ? "h-50" : ""}`)}>
    {image && (
      <>
        <TileImage src={image} alt="" fill sizes="(max-width: 1024px) 100vw, 900px" quality={PRODUCT_PHOTO_QUALITY} className="object-cover" preload />
        <span aria-hidden className="bg-scrim-listing absolute inset-0" />
      </>
    )}
    {!image &&
      cutouts?.map(({ src, className, sizes }) => (
        <Image key={src} src={src} alt="" aria-hidden width={400} height={400} sizes={sizes ?? "190px"} className={`pointer-events-none absolute object-contain ${className}`} />
      ))}
    <Stack gap="0" className="relative px-400 py-300 @3xl:px-500">
      <Text as="span" variant="body" family="text" tone="inverted" className="text-copy @3xl:text-copy-lg">
        {eyebrow}
      </Text>
      <Heading
        as="h1"
        family="hero"
        tone="inverted"
        balance
        className={`text-promo-title @3xl:text-promo-title-lg line-clamp-2 ${!image && cutouts?.length ? "max-w-52 @3xl:max-w-68" : "max-w-title"}`}
      >
        {title}
      </Heading>
    </Stack>
  </section>
)
